"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleAgreement = TitleAgreement;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./styles.css"));
var _formatString = require("../../utils/formatString");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function TitleAgreement(_ref) {
  let {
    viewData
  } = _ref;
  const content = React.useMemo(() => {
    if (viewData.phone) {
      return {
        title: /*#__PURE__*/React.createElement("span", null, "\u0421\u043E\u0437\u0434\u0430\u0451\u043C \u043D\u043E\u0432\u044B\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u043D\u0430\xA0\u043D\u043E\u043C\u0435\u0440"),
        subTitle: `${(0, _formatString.formatPhoneWithSpecialChars)(viewData.phone)}`
      };
    } else if (viewData.email) {
      return {
        title: /*#__PURE__*/React.createElement("span", null, "\u0421\u043E\u0437\u0434\u0430\u0451\u043C \u043D\u043E\u0432\u044B\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u043D\u0430\xA0\u043F\u043E\u0447\u0442\u0443"),
        subTitle: `${viewData.email}`
      };
    } else {
      return {
        title: /*#__PURE__*/React.createElement("span", null, "\u0421\u043E\u0437\u0434\u0430\u0451\u043C \u043D\u043E\u0432\u044B\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442")
      };
    }
  }, [viewData]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['title']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading3, null, content.title), content.subTitle && /*#__PURE__*/React.createElement("span", {
    className: styles['subtitle']
  }, content.subTitle));
}